import { motion } from "framer-motion";
import {
  CheckSquare, Brain, AlertTriangle, Calculator,
  FlaskConical, BookOpen, HelpCircle, Zap,
} from "lucide-react";
import { MODULES } from "@/lib/salesData";

const iconMap = {
  CheckSquare, Brain, AlertTriangle, Calculator,
  FlaskConical, BookOpen, HelpCircle, Zap,
};

export function ModulesSection() {
  return (
    <section id="modules" className="py-16 sm:py-24 bg-background">
      <div className="container max-w-7xl mx-auto px-4">

        {/* Header da seção */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-10 sm:mb-14"
        >
          <span className="text-accent text-xs font-semibold uppercase tracking-widest mb-3 block">
            O que está incluso
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
            Tudo que você precisa, em um só lugar.
          </h2>
          <p className="text-muted-foreground text-sm sm:text-base max-w-xl mx-auto">
            8 módulos integrados para transformar cada plantão oncológico em uma experiência segura e confiante.
          </p>
        </motion.div>

        {/* Grid de módulos — 1 col mobile / 2 col tablet / 4 col desktop */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {MODULES.map((module, index) => {
            const IconComponent = iconMap[module.icon as keyof typeof iconMap];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.06 }}
                whileHover={{ y: -6, scale: 1.02 }}
                className="bg-card border border-border rounded-2xl p-5 sm:p-6 cursor-default hover:border-accent/40 transition-all group"
              >
                {/* Ícone + emoji */}
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-2xl sm:text-3xl">{module.emoji}</span>
                  <div className="bg-accent/10 w-9 h-9 sm:w-10 sm:h-10 rounded-xl flex items-center justify-center group-hover:bg-accent/20 transition-colors">
                    {IconComponent && (
                      <IconComponent className="w-4 h-4 sm:w-5 sm:h-5 text-accent" />
                    )}
                  </div>
                </div>

                <h3 className="font-bold text-foreground text-sm sm:text-base mb-1 leading-snug">
                  {module.title}
                </h3>

                <p className="text-accent text-xs font-semibold uppercase tracking-wide mb-3">
                  {module.subtitle}
                </p>

                <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed mb-4">
                  {module.description}
                </p>

                {/* Tag do módulo */}
                <span className="inline-block bg-accent/10 border border-accent/20 text-accent text-xs font-semibold rounded-full px-3 py-0.5">
                  {module.tag}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
